import React from 'react';
import './Button.css';

const ButtonModal = ({ callFunction, buttonName }) => {
  return (
    <button
      name={buttonName}
      className="btn btn-secondary"
      type="submit"
      onClick={callFunction}
    >
      {' '}
      {buttonName}
      {' '}
    </button>
  );
};

export default ButtonModal;
